import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions, Button } from '../ui';

const TenantChangedModal: React.FC = () => {
  const [isOpen] = useState(true);

  const handleReload = () => {
    window.location.reload();
  };

  // No onClose handler since this is a forced action
  return (
    <Dialog open={isOpen} onClose={() => {}}>
      <DialogTitle>Organization Changed</DialogTitle>
      <DialogBody>
        <p>
          The active organization has been changed in another window. This page needs to reload to reflect the new
          organization context.
        </p>
      </DialogBody>
      <DialogActions>
        <Button type="button" color="blue" onClick={handleReload}>
          Reload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TenantChangedModal;
